import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  { _id: uuid(), categoryName: "All", description: "Coke Studio | All Songs" },
  {
    _id: uuid(),
    categoryName: "Season 14",
    description: "Coke Studio | Season 14",
  },
  {
    _id: uuid(),
    categoryName: "Season 12",
    description: "Coke Studio | Season 12",
  },
  {
    _id: uuid(),
    categoryName: "Season 11",
    description: "Coke Studio | Season 11",
  },
  {
    _id: uuid(),
    categoryName: "Season 10",
    description: "Coke Studio | Season 10",
  },
  {
    _id: uuid(),
    categoryName: "Season 9",
    description: "Coke Studio | Season 9",
  },
];
